import React from "react";
import styled from "styled-components";

import { ssm } from "../../../AppTheme.styled";
import { IButton } from "./Button.interface";

const StyledButton = styled.button<IButton>`
  border: none;
  outline: none;
  font-size: ${({ small, textBtn }) => (small || textBtn ? "14px" : "16px")};
  font-weight: 500;
  line-height: ${({ small }) => (small ? "120%" : "23px")};
  padding: ${({ small, textBtn }) =>
    small ? `${textBtn ? 0 : "8px 32px"}` : "12px 64px"};
  border-radius: 10px;
  width: ${({ small, fullWidth }) => (small && !fullWidth ? "auto" : "100%")};
  cursor: pointer;
  text-transform: ${({ textBtn, small }) =>
    textBtn && small ? "initial" : "uppercase"};
  box-sizing: border-box;
  letter-spacing: 0.03em;
  color: ${({ outlined, theme, textBtn, small, color }) =>
    outlined || textBtn
      ? `${
          small && !outlined
            ? theme.palette.neutral2
            : theme.palette[color || "primary"]
        }`
      : theme.palette.mainBackground};
  background-color: ${({ outlined, theme, textBtn, color }) =>
    outlined || textBtn ? "transparent" : theme.palette[color || "primary"]};
  border: ${({ outlined, theme, textBtn, color }) =>
    outlined && !textBtn
      ? `1px solid ${theme.palette[color || "primary"]}`
      : "none"};
  margin: ${({ spacing }) => (spacing ? spacing * 8 : 0)}px 4px;

  &[disabled] {
    cursor: not-allowed;
    opacity: ${({ theme }) => theme.disabledOpacity};
  }

  &:not([disabled]) {
    &:hover {
      opacity: ${({ outlined, theme, textBtn }) =>
        outlined && !textBtn ? 1 : theme.hoverOpacity};
      background-color: ${({ theme, textBtn, color }) =>
        textBtn ? "transparent" : theme.palette[color || "primary"]};
      color: ${({ theme, textBtn, color }) =>
        textBtn
          ? theme.palette[color || "primary"]
          : theme.palette.mainBackground};
    }
  }

  & > svg {
    margin-right: ${({ small }) => (small ? "4px" : "6px")};
    width: ${({ small }) => (small ? "9px" : "12px")};
    height: ${({ small }) => (small ? "9px" : "12px")};
  }

  ${ssm} {
    width: auto;
  }
`;

export default StyledButton;
